export default "__VITE_ASSET__DethX$MI__"